import { type Blocker, useBlocker } from 'react-router'
import { useCallback, useEffect, useRef } from 'react'

export function useBlockerAndUnload(props: {
  isExistChanges: boolean
  handleShowBlockerModal: (blocker: Blocker) => void
}) {
  const { isExistChanges, handleShowBlockerModal } = props
  const propsRef = useRef(props)
  propsRef.current = props
  const blocker = useBlocker(() => propsRef.current.isExistChanges)

  const beforeUnloadHandler = useCallback((event: BeforeUnloadEvent) => {
    event.preventDefault()
  }, [])

  useEffect(() => {
    return () => {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [])

  useEffect(() => {
    if (blocker.state === 'blocked') {
      handleShowBlockerModal(blocker)
    }
  }, [blocker])

  useEffect(() => {
    if (isExistChanges) {
      window.addEventListener('beforeunload', beforeUnloadHandler)
    } else {
      window.removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [isExistChanges])
  return { blocker }
}
